import { E } from '@angular/cdk/keycodes';
import { DOCUMENT } from '@angular/common';
import {
  Component,
  Inject,
  ElementRef,
  OnInit,
  Renderer2,
  AfterViewInit,
  Input,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ConfigService } from 'src/app/config/config.service';
import { InConfiguration } from 'src/app/core/models/config.interface';
import { AuthService } from 'src/app/core/service/auth.service';
import { LanguageService } from 'src/app/core/service/language.service';
import { DeleteItemComponent } from 'src/app/pages/delete-item/delete-item.component';
import { AppService } from 'src/app/services/app/app.service';
import { CommonService } from 'src/app/services/common/common.service';
import { GlobalService } from 'src/app/services/global/global.service';
import { IndividualService } from 'src/app/services/individual/individual.service';
import { UnsubscribeOnDestroyAdapter } from 'src/app/shared/UnsubscribeOnDestroyAdapter';
import { MatDialog } from '@angular/material/dialog';
import {
  trigger,
  transition,
  style,
  animate,
} from '@angular/animations';


interface Notifications {
  message: string;
  time: string;
  icon: string;
  color: string;
  status: string;
}

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  animations: [
    trigger('fadeOut', [
      transition(':leave', [
        animate('300ms ease-in', style({ opacity: 0, transform: 'translateX(20px)' }))
      ])
    ])
  ]
})
export class HeaderComponent
  extends UnsubscribeOnDestroyAdapter
  implements OnInit, AfterViewInit {
  public config!: InConfiguration;
  menuOpened = false;
  userImg?: string;
  homePage?: string;
  isNavbarCollapsed = true;
  flagvalue: string | string[] | undefined;
  countryName: string | string[] = [];
  langStoreValue?: string;
  defaultFlag?: string;
  isOpenSidebar?: boolean;
  docElement: HTMLElement | undefined;
  isFullScreen = false;
  public imageURL: any = GlobalService.imageURL;
  public userInfo: any;
  public isSellCourseBtn: boolean = false;
  @Input() sidebarSize: any = '';
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    public elementRef: ElementRef,
    private configService: ConfigService,
    private authService: AuthService,
    private router: Router,
    public languageService: LanguageService,
    private appService: AppService,
    private commonService: CommonService,
    private indivisualService: IndividualService,
    public dialog: MatDialog,
  ) {
    super();
  }
  listLang = [
    { text: 'English', flag: 'assets/images/flags/us.jpg', lang: 'en' },
    { text: 'Spanish', flag: 'assets/images/flags/spain.jpg', lang: 'es' },
    { text: 'German', flag: 'assets/images/flags/germany.jpg', lang: 'de' },
  ];
  notifications: Notifications[] = [];
  notificationArr: any[] = [];
  pageTitle: string = 'Default Title';
  public isUpgradeBtn: boolean = false;
  public isViewCompany: boolean = false;
  ngOnInit() {
    this.config = this.configService.configData;
    this.userImg = this.authService.currentUserValue.img;
    this.homePage = 'dashboard/dashboard1';
    this.langStoreValue = localStorage.getItem('lang') as string;
    const val = this.listLang.filter((x) => x.lang === this.langStoreValue);
    this.countryName = val.map((element) => element.text);
    if (val.length === 0) {
      if (this.flagvalue === undefined) {
        this.defaultFlag = 'assets/images/flags/us.jpg';
      }
    } else {
      this.flagvalue = val.map((element) => element.flag);
    }
    // adding on 8/5/2023 as full screen was not working otherwise
    this.docElement = document.documentElement;
    this.userInfo = this.appService.getData('training-portal.userInfo')

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        let route = this.router.routerState.root.firstChild;
        while (route) {
          if (route.outlet === 'primary') {
            this.pageTitle = route.snapshot.data['title'];
            break;
          }
          route = route.firstChild;
        }
      }
    });
    this.commonService.title.subscribe(value => {
      this.pageTitle = value
    })
    if (JSON.parse(this.userInfo).group_type == "company") {
      this.isUpgradeBtn = true
    }
    if (JSON.parse(this.userInfo).group_type == "individual") {
      this.isSellCourseBtn = true
    }
    // recruiter company can view client dashboard, at that time don't show them option to logout and upgrade hence hiding the upgrade button and logout
    if (this.appService.getSessionData('isViewCompany')) {
      this.isViewCompany = true;
    }

    this.getNotification()
  }

  getNotification() {

    let data = {
      "type": "0",
    }

    this.indivisualService.getNotification(data).subscribe({
      next: (success: any) => {
        if (success.status == 200) {
          this.notificationArr = success.data;
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }

  hideNotification(event: MouseEvent, id: any) {
    event.stopPropagation();
    const dialogRef = this.dialog.open(DeleteItemComponent, Object.assign({
      data: { api_type: "delete_content", content_type: "delete_notification", id: id }
    }));
    dialogRef.afterClosed().subscribe(result => {
      if (result && (result["delete_content"] == true)) {
        const index = this.notificationArr.findIndex(item => item.id === id);
        if (index !== -1) {
          this.notificationArr.splice(index, 1);
        }
      }
    });
  }

  ngAfterViewInit() {
    // set theme on startup
    if (localStorage.getItem('theme')) {
      this.renderer.removeClass(this.document.body, this.config.layout.variant);
      this.renderer.addClass(
        this.document.body,
        localStorage.getItem('theme') as string
      );
    } else {
      this.renderer.addClass(this.document.body, this.config.layout.variant);
    }

    if (localStorage.getItem('menuOption')) {
      this.renderer.addClass(
        this.document.body,
        localStorage.getItem('menuOption') as string
      );
    } else {
      this.renderer.addClass(
        this.document.body,
        'menu_' + this.config.layout.sidebar.backgroundColor
      );
    }

    if (localStorage.getItem('choose_logoheader')) {
      this.renderer.addClass(
        this.document.body,
        localStorage.getItem('choose_logoheader') as string
      );
    } else {
      this.renderer.addClass(
        this.document.body,
        'logo-' + this.config.layout.logo_bg_color
      );
    }

    if (localStorage.getItem('sidebar_status')) {
      if (localStorage.getItem('sidebar_status') === 'close') {
        this.renderer.addClass(this.document.body, 'side-closed');
        this.renderer.addClass(this.document.body, 'submenu-closed');
      } else {
        this.renderer.removeClass(this.document.body, 'side-closed');
        this.renderer.removeClass(this.document.body, 'submenu-closed');
      }
    } else {
      if (this.config.layout.sidebar.collapsed === true) {
        this.renderer.addClass(this.document.body, 'side-closed');
        this.renderer.addClass(this.document.body, 'submenu-closed');
      }
    }
  }
  callFullscreen() {
    if (!this.isFullScreen) {
      this.docElement?.requestFullscreen();
    } else {
      document.exitFullscreen();
    }
    this.isFullScreen = !this.isFullScreen;
  }
  setLanguage(text: string, lang: string, flag: string) {
    this.countryName = text;
    this.flagvalue = flag;
    this.langStoreValue = lang;
    this.languageService.setLanguage(lang);
  }
  mobileMenuSidebarOpen(event: Event, className: string) {
    const hasClass = (event.target as HTMLInputElement).classList.contains(
      className
    );
    if (hasClass) {
      this.renderer.removeClass(this.document.body, className);
    } else {
      this.renderer.addClass(this.document.body, className);
    }

    const hasClass2 = this.document.body.classList.contains('side-closed');
    if (hasClass2) {
      // this.renderer.removeClass(this.document.body, "side-closed");
      this.renderer.removeClass(this.document.body, 'submenu-closed');
    } else {
      // this.renderer.addClass(this.document.body, "side-closed");
      this.renderer.addClass(this.document.body, 'submenu-closed');
    }
  }
  callSidemenuCollapse() {
    const hasClass = this.document.body.classList.contains('side-closed');
    if (hasClass) {
      this.renderer.removeClass(this.document.body, 'side-closed');
      this.renderer.removeClass(this.document.body, 'submenu-closed');
    } else {
      this.renderer.addClass(this.document.body, 'side-closed');
      this.renderer.addClass(this.document.body, 'submenu-closed');
    }
  }

  logout() {
    this.appService.logOut();
  }

  onMenuOpened() {
    // Delay to allow view to update after Material renders the menu
    setTimeout(() => {
      this.menuOpened = true;
    }, 100);

    setTimeout(() => {
      const boxes = document.querySelectorAll('.cdk-overlay-connected-position-bounding-box');
      const boxesTrans = document.querySelectorAll('.cdk-overlay-transparent-backdrop');
      boxes.forEach(el => el.classList.add('my-custom-class'));
      boxesTrans.forEach(el => el.classList.add('my-custom-class'));
    }, 0);

  }

  onMenuClosed() {
    this.menuOpened = false;
  }
}
